.panel {
  display: block;
  margin-bottom: 8px;
  border: 1px solid #c0c0c0;
  border-radius: 8px;
  overflow: hidden;
}
.panel .title {
  background-image: linear-gradient(#f0f0f0, #e0e0e0);
  border-bottom: 2px solid #a0a0a0;
  color: #202020;
  min-height: 48px;
  line-height: 48px;
  padding-left: 8px;
}
.panel .content {
  background-image: linear-gradient(#f8f8f8, #e8e8e8);
}
.panel .contentMargin {
  padding: 8px;
}

:global(.dark) .panel {
  border: 1px solid #404040;
}
:global(.dark) .panel .title {
  background-image: linear-gradient(#606060, #303030);
  color: #d0d0d0;
  border-bottom: 2px solid #404040;
}
:global(.dark) .panel .content {
  background-image: linear-gradient(#505050, #202020);
}

.inputBlockWrap {
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 16px;
}
.inputBlockWrap .label {
  flex: 0 auto;
  margin-bottom: 0.25em;
}

.input {
  height: 34px;
  flex: 0 auto;
  border-radius: 4px;
  padding: 0px 8px;
  font-size: 16px;
  width: 100%;
}
.input.errored {
  border: 1px solid #711;
}
.input {
  border: 1px solid #a0a0a0;
  box-shadow: inset 1px 1px 3px 0px rgba(20, 20, 20, 0.3), 0px 0px 4px 0px rgba(20, 20, 20, 0.3);
  background-color: #f0f0f0;
}
.input.standard {
  min-height: 34px;
}

:global(.dark) .input {
  height: 34px;
  flex: 0 auto;
  border-radius: 4px;
  padding: 0px 8px;
  font-size: 16px;
  width: 100%;
}
:global(.dark) .input.errored {
  border: 1px solid #711;
}
:global(.dark) .input {
  border: 1px solid #606060;
  box-shadow: inset 1px 1px 4px 0px rgb(40, 40, 40), 0px 0px 4px 0px rgba(200, 200, 200, 0.2);
  background-color: #383838;
  color: #d0d0d0;
}
:global(.dark) .input.standard {
  min-height: 34px;
}
:global(.dark) .input:focus {
  border: 2px solid #808080;
  outline: green;
}
:global(.dark) .input:focus-visible {
  border: 2px solid #808080;
}
:global(.dark) .input:placeholder {
  color: red;
}

.textArea {
  flex: 0 auto;
  border-radius: 4px;
  padding: 0px 8px;
  font-size: 16px;
  width: 100%;
}
.textArea.errored {
  border: 1px solid #711;
}
.textArea {
  border: 1px solid #a0a0a0;
  box-shadow: inset 1px 1px 3px 0px rgba(20, 20, 20, 0.3), 0px 0px 4px 0px rgba(20, 20, 20, 0.3);
  background-color: #f0f0f0;
}

:global(.dark) .textArea {
  flex: 0 auto;
  border-radius: 4px;
  padding: 0px 8px;
  font-size: 16px;
  width: 100%;
}
:global(.dark) .textArea.errored {
  border: 1px solid #711;
}
:global(.dark) .textArea {
  border: 1px solid #606060;
  box-shadow: inset 1px 1px 4px 0px rgb(40, 40, 40), 0px 0px 4px 0px rgba(200, 200, 200, 0.2);
  background-color: #383838;
  color: #d0d0d0;
}
:global(.dark) .textArea.standard {
  min-height: 34px;
}
:global(.dark) .textArea:focus {
  border: 2px solid #808080;
  outline: green;
}
:global(.dark) .textArea:focus-visible {
  border: 2px solid #808080;
}
:global(.dark) .textArea:placeholder {
  color: red;
}

.itemHeader {
  display: inline-block;
}

.button {
  min-height: 34px;
  height: 34px;
  line-height: 34px;
  padding: 0px 8px;
  border: 1px solid #b0b0b0;
  background-image: linear-gradient(#f0f0f0, #c0c0c0);
  border-radius: 4px;
  margin: 0 4px;
  cursor: pointer;
}

:global(.dark) .button {
  background-image: linear-gradient(#505050, #303030);
  border: 1px solid #484848;
}

.checkboxWrap {
  margin-bottom: 16px;
}

.radioGroupWrap {
  margin-bottom: 16px;
}

.checkboxLabel, .radioLabel {
  margin-left: 8px;
}

.inputPanelWrap {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.error {
  position: relative;
  font-size: 12px;
  color: #711;
  padding: 4px;
}
.error .errorIcon {
  width: calc(100% - 8px);
  position: absolute;
  top: -26px;
  text-align: right;
  color: #711;
  pointer-events: none;
}

.select {
  height: 34px;
  padding: 6px;
  border: 1px solid #b0b0b0;
  background-image: linear-gradient(#ffffff, #f8f8f8, #e0e0e0);
  border-radius: 4px;
}

:global(.dark) .select {
  border: 1px solid #505050;
  background-image: linear-gradient(#606060, #404040, #202020);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */